export const INCOME = {
  nickname: 'PRODUCTS.INCOME.nickname',
  icon:'income'
};
